<div class="d-flex align-items-center justify-content-center">
  <div>
    <img class="logo" src="assets/themes/ccsf/images/admin-logo.svg" alt="{{'shared.card_header.title_image_alt' | translate}}"/>
    <h1 class="login-title text-align-center">{{'shared.card_header.title_text' | translate}}</h1>
  </div>
</div>
